import type React from 'react';

import { Navigate, useLocation } from 'react-router';
import type { MultiLang } from '../config';
import PageNotFound from './lib/PageNotFound';

interface Props {
    lang: MultiLang;
}

const XoopsPathRedirect: React.FC<Props> = (props) => {
    const { lang } = props;
    const location = useLocation();
    const { pathname } = location;
    const getRedirectUrl = () => {
        switch (pathname || '') {
            case '/index.php': {
                return '/';
            }
        }
        return '';
    };
    const url = getRedirectUrl();
    if (url === '') {
        return <PageNotFound lang={lang} />;
    }
    return <Navigate to={url} />;
};

export default XoopsPathRedirect;
